<template>
    <div>
        <el-row class="u-mt-10 u-mb-20">
            <el-col :xs="24" :sm="24" :md="24" class="u-text-right">
                <el-button v-if="podeGerir" type="primary" @click="abrirModalNova">NOVA FOLHA</el-button>
            </el-col>
        </el-row>

        <div class="container-table">
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th style="width: 160px;">Competência</th>
                        <th class="hidden-mobile" style="width: 210px;">Período abrangido</th>
                        <th style="width: 120px;" class="u-text-center">Situação</th>
                        <th class="hidden-mobile">Última alteração</th>
                        <th style="width: 90px;" class="u-text-center">Ação</th>
                    </tr>
                </thead>
                <tbody v-if="statusList">
                    <tr v-for="item in items" :key="item.id">
                        <td>{{ nomeMes(item.mes) }}/{{ item.ano }}</td>
                        <td class="hidden-mobile">{{ formataData(item.data_inicial) }} a {{ formataData(item.data_final) }}</td>
                        <td class="u-text-center">
                            <el-tag :type="cor(item.situacao)" size="small">{{ item.situacao_nome }}</el-tag>
                        </td>
                        <td class="hidden-mobile">
                            <template v-if="item.alterado_por">
                                {{ item.alterado_por }} em {{ formataDataHora(item.alterado_em) }}
                                <div v-if="item.observacao" class="sub-info">{{ item.observacao }}</div>
                            </template>
                            <span v-else class="sub-info">—</span>
                        </td>
                        <td class="u-text-center acao">
                            <el-button v-if="item.acoes.length" @click="abrirModalSituacao(item)" title="Editar"
                                type="info" icon="el-icon-edit" size="mini" plain></el-button>
                            <span v-else class="sub-info">—</span>
                        </td>
                    </tr>
                    <tr v-if="!items.length">
                        <td colspan="5" class="u-text-center">
                            Nenhuma folha criada.
                        </td>
                    </tr>
                </tbody>
            </table>

            <div v-if="!statusList" class="u-text-center u-mt-25">
                <img src="/public/img/loading-bar.gif" />
            </div>

            <el-row :gutter="10" v-if="statusList && items.length">
                <el-col :xs="24" :sm="12" :md="12">
                    <div class="u-text-left u-mt-10">{{ items.length }} folha(s) criada(s).</div>
                </el-col>
            </el-row>
        </div>

        <!-- Nova folha: mês e ano; nasce aberta. -->
        <el-dialog title="Nova Folha" :visible.sync="modalNova" width="480px" :close-on-click-modal="false">
            <el-form label-position="top" class="u-mt-20">
                <el-row :gutter="10">
                    <el-col :xs="14" :sm="14">
                        <el-form-item label="Mês">
                            <el-select v-model="nova.mes" style="width: 100%;">
                                <el-option v-for="(m, i) in meses" :key="i" :label="m" :value="i + 1"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="10" :sm="10">
                        <el-form-item label="Ano">
                            <el-input-number v-model="nova.ano" :min="2000" :max="2100" :controls="false"
                                style="width: 100%;"></el-input-number>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer">
                <el-button @click="modalNova = false">CANCELAR</el-button>
                <el-button type="primary" @click="criar" :loading="salvando">SALVAR</el-button>
            </span>
        </el-dialog>

        <!-- Situação: só as transições permitidas ao perfil chegam em item.acoes. -->
        <el-dialog :title="tituloSituacao" :visible.sync="modalSituacao" width="480px" :close-on-click-modal="false">
            <el-form label-position="top" class="u-mt-20">
                <el-row :gutter="10">
                    <el-col :xs="24">
                        <el-form-item label="Situação">
                            <el-select v-model="form.situacao" style="width: 100%;">
                                <el-option v-for="a in acoesDisponiveis" :key="a" :label="rotuloSituacao(a)" :value="a"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-alert v-if="form.situacao === 3" type="warning" :closable="false" class="u-mb-10"
                    title="Encerrada, a competência não aceita lançamentos das unidades. Somente SMED - Legalização e SMED - Recursos Humanos continuam alterando, e só um administrador reverte a situação."></el-alert>

                <el-row :gutter="10">
                    <el-col :xs="24">
                        <el-form-item label="Observação (opcional)">
                            <el-input v-model="form.observacao" maxlength="255" placeholder="Motivo ou referência"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer">
                <el-button @click="modalSituacao = false">CANCELAR</el-button>
                <el-button type="primary" @click="salvarSituacao" :loading="salvando">SALVAR</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
const MESES = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
    'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro']

export default {
    data: () => ({
        statusList: false,
        salvando: false,
        items: [],
        podeGerir: false,
        podeReabrir: false,
        meses: MESES,
        modalNova: false,
        modalSituacao: false,
        nova: { mes: new Date().getMonth() + 1, ano: new Date().getFullYear() },
        form: { id: '', situacao: null, observacao: '' },
        acoesDisponiveis: [],
        itemAtual: null
    }),
    computed: {
        tituloSituacao () {
            return this.itemAtual
                ? `Situação — ${this.nomeMes(this.itemAtual.mes)}/${this.itemAtual.ano}`
                : 'Situação'
        }
    },
    mounted () {
        this.load()
    },
    methods: {
        baseUrl () {
            return `${this.$store.state.config.baseUrlApi}/api/folha-ponto`
        },
        nomeMes (mes) { return MESES[mes - 1] },
        cor (situacao) {
            if (situacao === 3) return 'danger'
            if (situacao === 2) return 'warning'
            return 'success'
        },
        rotuloSituacao (situacao) {
            if (situacao === 1) return 'Aberta'
            if (situacao === 2) return 'Bloqueada'
            return 'Encerrada'
        },
        formataData (data) {
            if (!data) return '-'
            const d = String(data).substring(0, 10).split('-')
            return d.length === 3 ? `${d[2]}/${d[1]}/${d[0]}` : data
        },
        formataDataHora (valor) {
            if (!valor) return '-'
            return `${this.formataData(valor)} ${String(valor).substring(11, 16)}`
        },
        erro (e) {
            const msg = e && e.response && e.response.data && e.response.data.throw
                ? e.response.data.throw.msg
                : 'Não foi possível concluir a operação.'

            window.eventBus.$emit('alert', { msg, type: 'warning' })
            this.$store.commit('throwException', e)
        },
        aplicar (dados) {
            this.items = dados.itens || []
            this.podeGerir = !!dados.pode_gerir
            this.podeReabrir = !!dados.pode_reabrir
            this.statusList = true
        },
        load () {
            this.statusList = false
            this.$axios.get(`${this.baseUrl()}/competencia`, this.$store.getters.getHeaderAuth)
                .then(res => this.aplicar(res.data))
                .catch(e => { this.statusList = true; this.erro(e) })
        },
        abrirModalNova () {
            this.nova = { mes: new Date().getMonth() + 1, ano: new Date().getFullYear() }
            this.modalNova = true
        },
        criar () {
            this.salvando = true
            this.$axios.post(`${this.baseUrl()}/competencia/store`, this.nova, this.$store.getters.getHeaderAuth)
                .then(res => {
                    this.salvando = false
                    this.modalNova = false
                    this.aplicar(res.data)
                    window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
                })
                .catch(e => { this.salvando = false; this.erro(e) })
        },
        abrirModalSituacao (item) {
            this.itemAtual = item
            this.acoesDisponiveis = item.acoes
            this.form = { id: item.id, situacao: item.acoes[0], observacao: item.observacao || '' }
            this.modalSituacao = true
        },
        salvarSituacao () {
            this.salvando = true
            this.$axios.post(`${this.baseUrl()}/competencia/update/${this.form.id}`,
                { situacao: this.form.situacao, observacao: this.form.observacao },
                this.$store.getters.getHeaderAuth)
                .then(res => {
                    this.salvando = false
                    this.modalSituacao = false
                    this.aplicar(res.data)
                    window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
                })
                .catch(e => { this.salvando = false; this.erro(e) })
        }
    }
}
</script>

<style scoped>
.sub-info { color: #909399; font-size: 12px; }
</style>
